import { Checkbox, CheckboxProps, FormControlLabel } from "@mui/material";
import { useFormContext, useController } from "react-hook-form";
import LabeledText from "./LabeledText";
import { useMemo } from "react";

interface IProps {
    fieldName : string,
    label: string,
    readOnly: boolean,
    showHideInsteadOfIcon?: boolean
}

type CheckBoxFormProps = CheckboxProps & IProps;

const CheckBoxForm = ({fieldName, label, readOnly, onChange, onBlur, showHideInsteadOfIcon, ...rest} : CheckBoxFormProps) => {
    
    const { control } = useFormContext();
    const { field } = useController({
        name: fieldName,
        control: control
    });

    const hideForm: boolean = useMemo(() => {
        if (!readOnly) {
            return false;
        }
        if (showHideInsteadOfIcon) {
            return !field.value
        }

        return false;
    }, [readOnly, showHideInsteadOfIcon, field.value]);

    function handleOnChange(e : any) {
        if (!readOnly) {
            field.onChange(e);
            if (onChange) onChange(e, e.target.checked);
        }
    }
    
    function handleOnBlur(e : any) {
        field.onBlur();
        if (onBlur) onBlur(e);
    }

    if (hideForm) {
        return <></>;
    }

    if (readOnly) {
        return <LabeledText
            label={""}
            text={label}
            isChecked={showHideInsteadOfIcon ? undefined : field.value}
        />
    }

    return <>
        <FormControlLabel
            control={
                <Checkbox
                    ref={field.ref}
                    inputRef={field.ref}
                    checked={field.value}
                    onChange={handleOnChange}
                    onBlur={handleOnBlur}
                    {...rest}
                />}
            label={label}
        />
    </>
}

export default CheckBoxForm;